import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import ReactDOM from "react-dom";
import $ from 'jquery';
import './HeaderNavBar.css';
import { Modal } from 'react-bootstrap';
import Spinner from '../Spinner/Spinner';
import { GrFormClose } from 'react-icons/gr';
import { AiOutlineUnderline } from "react-icons/ai";
import { useSelector, useDispatch } from 'react-redux';
import loaderColors1 from '../Spinner/loaderColors1.gif';
import { DropdownSubmenu, NavDropdownMenu } from "react-bootstrap-submenu";
import { handleException, reCalculateNotesOnRight, reCalculateBriefOnRight } from "../../app/util/util";
import { setLabelVOList, setRemovedLabelVOList, setLabelSettingsVOList, setRemovedColorsVOList, setUserSettingVO } from '../../app/redux/UserSlice';
let selectedColorList = [], selectedColorBriefList = [], colorCodeVOList = [], hiddenColorList = [], hiddenColorBriefList = [],
    labelVOListLocal = [], labelBriefSetting = [], labelBriefSetting1 = [];
let revertStyleFlag = false;
let colorCodeList = [
    { id: "colorBtnTypeOne1", color: '#EDE48C', colorCode: '#EDE48C', title: 'Yellow' },
    { id: "colorBtnTypeTwo1", color: '#B5EB97', colorCode: '#B5EB97', title: 'Green' },
    { id: "colorBtnTypeThree1", color: '#AEE6FE', colorCode: '#AEE6FE', title: 'Blue' },
    { id: "colorBtnTypeFour1", color: '#FEC0FF', colorCode: '#FEC0FF', title: 'Pink' },
    { id: "colorBtnTypeFive1", color: '#FFD4A8', colorCode: '#FFD4A8', title: 'Orange' },
    { id: "colorBtnTypeSix1", color: '#CBBEFC', colorCode: '#CBBEFC', title: 'Purple' },
    { id: "colorBtnTypeSeven1", color: '#35FBE2', colorCode: '#35FBE2', title: 'Cyan' },
    { id: "colorBtnTypeEight1", color: '#95A7FF', colorCode: '#95A7FF', title: 'Indigo' },
    { id: "colorBtnTypeNine1", color: '#FF8787', colorCode: '#FF8787', title: 'Red' },
    { id: "colorBtnTypeTen1", color: '#C1A88E', colorCode: '#C1A88E', title: 'Brown' },
    { id: "colorBtnTypeEleven1", color: '#DADADA', colorCode: '#DADADA', title: 'Gray' },
    { id: "underLine", color: 'underLine', colorCode: 'underLine', title: 'underLine' },
];
let colorCodeBriefList = [
    {
        id: "colorBtnTypeOneBR", color: '#EDE48C', colorCode: '#EDE48C',
        inputType: 'inputTypeOne', title: 'Yellow', orderIndex: '1', labelName: "colorBtnTypeOneBRText"
    },
    {
        id: "colorBtnTypeTwoBR", color: '#B5EB97', colorCode: '#B5EB97',
        inputType: 'inputTypeTwo', title: 'Green', orderIndex: '2', labelName: "colorBtnTypeTwoBRText"
    },
    {
        id: "colorBtnTypeThreeBR", color: '#AEE6FE', colorCode: '#AEE6FE',
        inputType: 'inputTypeThree', title: 'Blue', orderIndex: '3', labelName: "colorBtnTypeThreeBRText"
    },
    {
        id: "colorBtnTypeFourBR", color: '#FEC0FF', colorCode: '#FEC0FF',
        inputType: 'inputTypeFour', title: 'Pink', orderIndex: '4', labelName: "colorBtnTypeFourBRText"
    },
    {
        id: "colorBtnTypeFiveBR", color: '#FFD4A8', colorCode: '#FFD4A8',
        inputType: 'inputTypeFive', title: 'Orange', orderIndex: '5', labelName: "colorBtnTypeFiveBRText"
    },
    {
        id: "colorBtnTypeSixBR", color: '#CBBEFC', colorCode: '#CBBEFC',
        inputType: 'inputTypeSix', title: 'Purple', orderIndex: '6', labelName: "colorBtnTypeSixBRText"
    },
    {
        id: "colorBtnTypeSevenBR", color: '#35FBE2', colorCode: '#35FBE2',
        inputType: 'inputTypeSeven', title: 'Cyan', orderIndex: '7', labelName: "colorBtnTypeSevenBRText"
    },
    {
        id: "colorBtnTypeEightBR", color: '#95A7FF', colorCode: '#95A7FF',
        inputType: 'inputTypeEight', title: 'Indigo', orderIndex: '8', labelName: "colorBtnTypeEightBRText"
    },
    {
        id: "colorBtnTypeNineBR", color: '#FF8787', colorCode: '#FF8787',
        inputType: 'inputTypeNine', title: 'Red', orderIndex: '9', labelName: "colorBtnTypeNineBRText"
    },
    {
        id: "colorBtnTypeTenBR", color: '#C1A88E', colorCode: '#C1A88E',
        inputType: 'inputTypeTen', title: 'Brown', orderIndex: '10', labelName: "colorBtnTypeTenBRText"
    },
    {
        id: "colorBtnTypeElevenBR", color: '#DADADA', colorCode: '#DADADA',
        inputType: 'inputTypeEleven', title: 'Gray', orderIndex: '11', labelName: "colorBtnTypeElevenBRText"
    },
    {
        id: "underLine", color: 'underLine', colorCode: 'underLine',
        inputType: 'inputTypeUnderLine', title: 'Underline', orderIndex: '12', labelName: "colorBtnTypeUnderLineBRText"
    }
];
function SettingsMenu(props) {
    const dispatch = useDispatch();
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const keepMeLogIn = localStorage.getItem('keepLoggedIn') ? "true" : "false";
    const [fontSize, setFontSize] = useState("14");
    const [loadSpin, setLoadSpin] = useState(false);
    const [lineHeight, setLineHeight] = useState("12");
    const [editBriefOpen, setBriefOpen] = useState(false);
    const [briefPopoverSave, setBriefPopoverSave] = useState(false);
    const [eBookStyleIsOpen, setEBookStyleIsOpen] = useState(false);
    const [briefPopoverCancel, setBriefPopoverCancel] = useState(false);
    const { labelSettingsVOList } = useSelector((state) => state.userVO);
    const [briefCodeVOListState, setBriefCodeVOListState] = useState([]);
    const [editHighlighterOpen, setEditHighlighterOpen] = useState(false);
    const [colorBtnTypeOneBRText, setColorBtnTypeOneBRText] = useState("");
    const [colorBtnTypeTwoBRText, setColorBtnTypeTwoBRText] = useState("");
    const [colorBtnTypeSixBRText, setColorBtnTypeSixBRText] = useState("");
    const [colorBtnTypeTenBRText, setColorBtnTypeTenBRText] = useState("");
    const [colorBtnTypeFourBRText, setColorBtnTypeFourBRText] = useState("");
    const [colorBtnTypeFiveBRText, setColorBtnTypeFiveBRText] = useState("");
    const [colorBtnTypeNineBRText, setColorBtnTypeNineBRText] = useState("");
    const [colorBtnTypeThreeBRText, setColorBtnTypeThreeBRText] = useState("");
    const [colorBtnTypeSevenBRText, setColorBtnTypeSevenBRText] = useState("");
    const [colorBtnTypeEightBRText, setColorBtnTypeEightBRText] = useState("");
    const [highlighterPopoverSave, setHighlighterPopoverSave] = useState(false);
    const [colorBtnTypeElevenBRText, setColorBtnTypeElevenBRText] = useState("");
    const [saveBtnAriaLabel, setSaveBtnAriaLabel] = useState('Yes, Save Changes');
    const [hiddenColorBriefListState, setHiddenColorBriefListState] = useState([]);
    const [highlighterPopoverCancel, setHighlighterPopoverCancel] = useState(false);
    const [colorBtnTypeUnderLineBRText, setColorBtnTypeUnderLineBRText] = useState("");
    const [hiddenColorText, setHiddenColorText] = useState("There are no hidden highlighters.");
    const [casesFlag, setCasesFlag] = useState(props.bookVO.casesFlag === "true" ? true : false);
    const [selectColorText, setselectColorText] = useState("Click on a color to remove it from your highlighters.");
    const [briefHiddenColorText, setBriefHiddenColorText] = useState("Click on a color to add it to your highlighters and case briefs.");
    const [state, setState] = useState({
        colorBtnTypeTen1: false, colorBtnTypeEleven1: false, underLineSt: false, colorBtnTypeOne1: false, colorBtnTypeTwo1: false, colorBtnTypeThree1: false,
        colorBtnTypeFour1: false, colorBtnTypeFive1: false, colorBtnTypeSix1: false, underLineStHidden: false, colorBtnTypeOneBR: false, colorBtnTypeTwoBR: false,
        colorBtnTypeSeven1: false, colorBtnTypeEight1: false, colorBtnTypeNine1: false, colorBtnTypeThreeBR: false, colorBtnTypeFourBR: false, colorBtnTypeFiveBR: false,
        colorBtnTypeSixBR: false, colorBtnTypeSevenBR: false, colorBtnTypeEightBR: false, colorBtnTypeNineBRText: false, colorBtnTypeTenBRText: false, colorBtnTypeElevenBR: false, colorBtnTypeUnderLineBR: false,
    });
    const getSessionVO = () => {
        return {
            "appType": "web",
            "deviceMacId": "",
            "keepMeLoggedInFlag": keepMeLogIn,
            "deviceOS": localStorage.getItem('deviceOS'),
            "deviceType": localStorage.getItem('deviceType'),
            "browserName": localStorage.getItem('browserName'),
            "sessionAuthenticationToken": userVO.sessionAuthenticationToken
        }
    }
    useEffect(() => {
        async function fetchHighlightSettings() {
            dispatch(setUserSettingVO(props.userSettingsVO));
            dispatch(setLabelVOList(props.bookVO.labelVOList));
            dispatch(setRemovedLabelVOList(props.briefVOList));
            dispatch(setLabelSettingsVOList(props.bookVO.labelVOList));
            casesFlag ? dispatch(setRemovedColorsVOList(props.briefVOList)) : dispatch(setRemovedColorsVOList(props.annotationVOList));
            getLatestBriefs(); getLatestHighlights();
        }
        fetchHighlightSettings();
    }, []);
    useEffect(() => {
        getLatestBriefs();
        getLatestHighlights();
    }, [labelSettingsVOList]);
    const getLatestHighlights = () => {
        colorCodeList = [
            { id: "colorBtnTypeOne1", color: '#EDE48C', colorCode: '#EDE48C', title: 'Yellow' },
            { id: "colorBtnTypeTwo1", color: '#B5EB97', colorCode: '#B5EB97', title: 'Green' },
            { id: "colorBtnTypeThree1", color: '#AEE6FE', colorCode: '#AEE6FE', title: 'Blue' },
            { id: "colorBtnTypeFour1", color: '#FEC0FF', colorCode: '#FEC0FF', title: 'Pink' },
            { id: "colorBtnTypeFive1", color: '#FFD4A8', colorCode: '#FFD4A8', title: 'Orange' },
            { id: "colorBtnTypeSix1", color: '#CBBEFC', colorCode: '#CBBEFC', title: 'Purple' },
            { id: "colorBtnTypeSeven1", color: '#35FBE2', colorCode: '#35FBE2', title: 'Cyan' },
            { id: "colorBtnTypeEight1", color: '#95A7FF', colorCode: '#95A7FF', title: 'Indigo' },
            { id: "colorBtnTypeNine1", color: '#FF8787', colorCode: '#FF8787', title: 'Red' },
            { id: "colorBtnTypeTen1", color: '#C1A88E', colorCode: '#C1A88E', title: 'Brown' },
            { id: "colorBtnTypeEleven1", color: '#DADADA', colorCode: '#DADADA', title: 'Gray' },
            { id: "underLine", color: 'underLine', colorCode: 'underLine', title: 'Underline' },
        ];
        let hiddenColorCodes = JSON.parse(localStorage.getItem("colorCodeVOList"));
        if (localStorage.getItem("colorCodeVOList") !== null) {
            if (hiddenColorCodes !== null) {
                for (let i = 0; i < hiddenColorCodes.length; i++) {
                    if (hiddenColorCodes[i].highlightColorCode.toUpperCase() === "#EDE48C") {
                        hiddenColorCodes[i].title = 'Yellow';
                        hiddenColorCodes[i].id = "colorBtnTypeOne1";
                    } else if (hiddenColorCodes[i].highlightColorCode.toUpperCase() === "#B5EB97") {
                        hiddenColorCodes[i].title = 'Green';
                        hiddenColorCodes[i].id = "colorBtnTypeTwo1";
                    } else if (hiddenColorCodes[i].highlightColorCode.toUpperCase() === "#AEE6FE") {
                        hiddenColorCodes[i].title = 'Blue';
                        hiddenColorCodes[i].id = "colorBtnTypeThree1";
                    } else if (hiddenColorCodes[i].highlightColorCode.toUpperCase() === "#FEC0FF") {
                        hiddenColorCodes[i].title = 'Pink';
                        hiddenColorCodes[i].id = "colorBtnTypeFour1";
                    } else if (hiddenColorCodes[i].highlightColorCode.toUpperCase() === "#FFD4A8") {
                        hiddenColorCodes[i].title = 'Orange';
                        hiddenColorCodes[i].id = "colorBtnTypeFive1";
                    } else if (hiddenColorCodes[i].highlightColorCode.toUpperCase() === "#CBBEFC") {
                        hiddenColorCodes[i].title = 'Purple';
                        hiddenColorCodes[i].id = "colorBtnTypeSix1";
                    } else if (hiddenColorCodes[i].highlightColorCode.toUpperCase() === "#35FBE2") {
                        hiddenColorCodes[i].title = 'Cyan';
                        hiddenColorCodes[i].id = "colorBtnTypeSeven1";
                    } else if (hiddenColorCodes[i].highlightColorCode.toUpperCase() === "#95A7FF") {
                        hiddenColorCodes[i].title = 'Indigo';
                        hiddenColorCodes[i].id = "colorBtnTypeEight1";
                    } else if (hiddenColorCodes[i].highlightColorCode.toUpperCase() === "#FF8787") {
                        hiddenColorCodes[i].title = 'Red';
                        hiddenColorCodes[i].id = "colorBtnTypeNine1";
                    } else if (hiddenColorCodes[i].highlightColorCode.toUpperCase() === "#C1A88E") {
                        hiddenColorCodes[i].title = 'Brown';
                        hiddenColorCodes[i].id = "colorBtnTypeTen1";
                    } else if (hiddenColorCodes[i].highlightColorCode.toUpperCase() === "#DADADA") {
                        hiddenColorCodes[i].title = 'Gray';
                        hiddenColorCodes[i].id = "colorBtnTypeEleven1";
                    } else if (hiddenColorCodes[i].highlightColorCode.toUpperCase() === "underLine") {
                        hiddenColorCodes[i].id = "underLine";
                        hiddenColorCodes[i].title = 'Underline';
                    }
                    colorCodeList.splice(colorCodeList.findIndex(item => item.color === hiddenColorCodes[i].highlightColorCode), 1)
                }
            }
        }
        colorCodeVOList = [...colorCodeList]; hiddenColorList = hiddenColorCodes !== null ? [...hiddenColorCodes] : [];
        if (hiddenColorList.length !== 0) { setHiddenColorText("Click a color to add it back to your e-book highlighters."); }
        else { setHiddenColorText("There are no hidden highlighters."); }
    }
    const getLatestBriefs = () => {
        colorCodeBriefList = [
            {
                id: "colorBtnTypeOneBR", color: '#EDE48C', colorCode: '#EDE48C',
                inputType: 'inputTypeOne', title: 'Yellow', orderIndex: '1', labelName: "colorBtnTypeOneBRText"
            },
            {
                id: "colorBtnTypeTwoBR", color: '#B5EB97', colorCode: '#B5EB97',
                inputType: 'inputTypeTwo', title: 'Green', orderIndex: '2', labelName: "colorBtnTypeTwoBRText"
            },
            {
                id: "colorBtnTypeThreeBR", color: '#AEE6FE', colorCode: '#AEE6FE',
                inputType: 'inputTypeThree', title: 'Blue', orderIndex: '3', labelName: "colorBtnTypeThreeBRText"
            },
            {
                id: "colorBtnTypeFourBR", color: '#FEC0FF', colorCode: '#FEC0FF',
                inputType: 'inputTypeFour', title: 'Pink', orderIndex: '4', labelName: "colorBtnTypeFourBRText"
            },
            {
                id: "colorBtnTypeFiveBR", color: '#FFD4A8', colorCode: '#FFD4A8',
                inputType: 'inputTypeFive', title: 'Orange', orderIndex: '5', labelName: "colorBtnTypeFiveBRText"
            },
            {
                id: "colorBtnTypeSixBR", color: '#CBBEFC', colorCode: '#CBBEFC',
                inputType: 'inputTypeSix', title: 'Purple', orderIndex: '6', labelName: "colorBtnTypeSixBRText"
            },
            {
                id: "colorBtnTypeSevenBR", color: '#35FBE2', colorCode: '#35FBE2',
                inputType: 'inputTypeSeven', title: 'Cyan', orderIndex: '7', labelName: "colorBtnTypeSevenBRText"
            },
            {
                id: "colorBtnTypeEightBR", color: '#95A7FF', colorCode: '#95A7FF',
                inputType: 'inputTypeEight', title: 'Indigo', orderIndex: '8', labelName: "colorBtnTypeEightBRText"
            },
            {
                id: "colorBtnTypeNineBR", color: '#FF8787', colorCode: '#FF8787',
                inputType: 'inputTypeNine', title: 'Red', orderIndex: '9', labelName: "colorBtnTypeNineBRText"
            },
            {
                id: "colorBtnTypeTenBR", color: '#C1A88E', colorCode: '#C1A88E',
                inputType: 'inputTypeTen', title: 'Brown', orderIndex: '10', labelName: "colorBtnTypeTenBRText"
            },
            {
                id: "colorBtnTypeElevenBR", color: '#DADADA', colorCode: '#DADADA',
                inputType: 'inputTypeEleven', title: 'Gray', orderIndex: '11', labelName: "colorBtnTypeElevenBRText"
            },
            {
                id: "underLine", color: 'underLine', colorCode: 'underLine',
                inputType: 'inputTypeUnderLine', title: 'Underline', orderIndex: '12', labelName: "colorBtnTypeUnderLineBRText"
            }
        ];
        labelBriefSetting1 = [];
        labelBriefSetting = labelSettingsVOList;
        if (labelBriefSetting !== null) {
            for (let index = 0; index < labelBriefSetting.length; index++) {
                if (labelBriefSetting[index].colorCode !== undefined) {
                    labelBriefSetting1[index] = {};
                    if (labelBriefSetting[index].colorCode.toUpperCase() === "#EDE48C") {
                        labelBriefSetting1[index].title = "Yellow";
                        labelBriefSetting1[index].color = "#EDE48C";
                        labelBriefSetting1[index].colorCode = "#EDE48C";
                        labelBriefSetting1[index].id = "colorBtnTypeOneBR";
                        labelBriefSetting1[index].inputType = "inputTypeOne";
                        labelBriefSetting1[index].label = "colorBtnTypeOneBRText";
                        labelBriefSetting1[index].labelId = labelBriefSetting[index].labelId;
                        labelBriefSetting1[index].labelName = labelBriefSetting[index].labelName;
                        labelBriefSetting1[index].orderIndex = labelBriefSetting[index].orderIndex;
                        setColorBtnTypeOneBRText(labelBriefSetting[index].labelName);
                    } else if (labelBriefSetting[index].colorCode.toUpperCase() === "#B5EB97") {
                        labelBriefSetting1[index].title = "Green";
                        labelBriefSetting1[index].color = "#B5EB97";
                        labelBriefSetting1[index].colorCode = "#B5EB97";
                        labelBriefSetting1[index].id = "colorBtnTypeTwoBR";
                        labelBriefSetting1[index].inputType = "inputTypeTwo";
                        labelBriefSetting1[index].label = "colorBtnTypeTwoBRText";
                        labelBriefSetting1[index].labelId = labelBriefSetting[index].labelId;
                        labelBriefSetting1[index].labelName = labelBriefSetting[index].labelName;
                        labelBriefSetting1[index].orderIndex = labelBriefSetting[index].orderIndex;
                        setColorBtnTypeTwoBRText(labelBriefSetting[index].labelName);
                    } else if (labelBriefSetting[index].colorCode.toUpperCase() === "#AEE6FE") {
                        labelBriefSetting1[index].title = "Blue";
                        labelBriefSetting1[index].color = "#AEE6FE";
                        labelBriefSetting1[index].colorCode = "#AEE6FE";
                        labelBriefSetting1[index].id = "colorBtnTypeThreeBR";
                        labelBriefSetting1[index].inputType = "inputTypeThree";
                        labelBriefSetting1[index].label = "colorBtnTypeThreeBRText";
                        labelBriefSetting1[index].labelId = labelBriefSetting[index].labelId;
                        labelBriefSetting1[index].labelName = labelBriefSetting[index].labelName;
                        labelBriefSetting1[index].orderIndex = labelBriefSetting[index].orderIndex;
                        setColorBtnTypeThreeBRText(labelBriefSetting[index].labelName);
                    } else if (labelBriefSetting[index].colorCode.toUpperCase() === "#FEC0FF") {
                        labelBriefSetting1[index].title = "Pink";
                        labelBriefSetting1[index].color = "#FEC0FF";
                        labelBriefSetting1[index].colorCode = "#FEC0FF";
                        labelBriefSetting1[index].id = "colorBtnTypeFourBR";
                        labelBriefSetting1[index].inputType = "inputTypeFour";
                        labelBriefSetting1[index].label = "colorBtnTypeFourBRText";
                        labelBriefSetting1[index].labelId = labelBriefSetting[index].labelId;
                        labelBriefSetting1[index].labelName = labelBriefSetting[index].labelName;
                        labelBriefSetting1[index].orderIndex = labelBriefSetting[index].orderIndex;
                        setColorBtnTypeFourBRText(labelBriefSetting[index].labelName);
                    } else if (labelBriefSetting[index].colorCode.toUpperCase() === "#FFD4A8") {
                        labelBriefSetting1[index].title = "Orange";
                        labelBriefSetting1[index].color = "#FFD4A8";
                        labelBriefSetting1[index].colorCode = "#FFD4A8";
                        labelBriefSetting1[index].id = "colorBtnTypeFiveBR";
                        labelBriefSetting1[index].inputType = "inputTypeFive";
                        labelBriefSetting1[index].label = "colorBtnTypeFiveBRText";
                        labelBriefSetting1[index].labelId = labelBriefSetting[index].labelId;
                        labelBriefSetting1[index].labelName = labelBriefSetting[index].labelName;
                        labelBriefSetting1[index].orderIndex = labelBriefSetting[index].orderIndex;
                        setColorBtnTypeFiveBRText(labelBriefSetting[index].labelName);
                    } else if (labelBriefSetting[index].colorCode.toUpperCase() === "#CBBEFC") {
                        labelBriefSetting1[index].title = "Purple";
                        labelBriefSetting1[index].color = "#CBBEFC";
                        labelBriefSetting1[index].colorCode = "#CBBEFC";
                        labelBriefSetting1[index].id = "colorBtnTypeSixBR";
                        labelBriefSetting1[index].inputType = "inputTypeSix";
                        labelBriefSetting1[index].label = "colorBtnTypeSixBRText";
                        labelBriefSetting1[index].labelId = labelBriefSetting[index].labelId;
                        labelBriefSetting1[index].labelName = labelBriefSetting[index].labelName;
                        labelBriefSetting1[index].orderIndex = labelBriefSetting[index].orderIndex;
                        setColorBtnTypeSixBRText(labelBriefSetting[index].labelName);
                    } else if (labelBriefSetting[index].colorCode.toUpperCase() === "#35FBE2") {
                        labelBriefSetting1[index].title = "Cyan";
                        labelBriefSetting1[index].color = "#35FBE2";
                        labelBriefSetting1[index].colorCode = "#35FBE2";
                        labelBriefSetting1[index].id = "colorBtnTypeSevenBR";
                        labelBriefSetting1[index].inputType = "inputTypeSeven";
                        labelBriefSetting1[index].label = "colorBtnTypeSevenBRText";
                        labelBriefSetting1[index].labelId = labelBriefSetting[index].labelId;
                        labelBriefSetting1[index].labelName = labelBriefSetting[index].labelName;
                        labelBriefSetting1[index].orderIndex = labelBriefSetting[index].orderIndex;
                        setColorBtnTypeSevenBRText(labelBriefSetting[index].labelName);
                    } else if (labelBriefSetting[index].colorCode.toUpperCase() === "#95A7FF") {
                        labelBriefSetting1[index].title = "Indigo";
                        labelBriefSetting1[index].color = "#95A7FF";
                        labelBriefSetting1[index].colorCode = "#95A7FF";
                        labelBriefSetting1[index].id = "colorBtnTypeEightBR";
                        labelBriefSetting1[index].inputType = "inputTypeEight";
                        labelBriefSetting1[index].label = "colorBtnTypeEightBRText";
                        labelBriefSetting1[index].labelId = labelBriefSetting[index].labelId;
                        labelBriefSetting1[index].labelName = labelBriefSetting[index].labelName;
                        labelBriefSetting1[index].orderIndex = labelBriefSetting[index].orderIndex;
                        setColorBtnTypeEightBRText(labelBriefSetting[index].labelName);
                    } else if (labelBriefSetting[index].colorCode.toUpperCase() === "#FF8787") {
                        labelBriefSetting1[index].title = "Red";
                        labelBriefSetting1[index].color = "#FF8787";
                        labelBriefSetting1[index].colorCode = "#FF8787";
                        labelBriefSetting1[index].id = "colorBtnTypeNineBR";
                        labelBriefSetting1[index].inputType = "inputTypeNine";
                        labelBriefSetting1[index].label = "colorBtnTypeNineBRText";
                        labelBriefSetting1[index].labelId = labelBriefSetting[index].labelId;
                        labelBriefSetting1[index].labelName = labelBriefSetting[index].labelName;
                        labelBriefSetting1[index].orderIndex = labelBriefSetting[index].orderIndex;
                        setColorBtnTypeNineBRText(labelBriefSetting[index].labelName);
                    } else if (labelBriefSetting[index].colorCode.toUpperCase() === "#C1A88E") {
                        labelBriefSetting1[index].title = "Brown";
                        labelBriefSetting1[index].color = "#C1A88E";
                        labelBriefSetting1[index].colorCode = "#C1A88E";
                        labelBriefSetting1[index].id = "colorBtnTypeTenBR";
                        labelBriefSetting1[index].inputType = "inputTypeTen";
                        labelBriefSetting1[index].label = "colorBtnTypeTenBRText";
                        labelBriefSetting1[index].labelId = labelBriefSetting[index].labelId;
                        labelBriefSetting1[index].labelName = labelBriefSetting[index].labelName;
                        labelBriefSetting1[index].orderIndex = labelBriefSetting[index].orderIndex;
                        setColorBtnTypeTenBRText(labelBriefSetting[index].labelName);
                    } else if (labelBriefSetting[index].colorCode.toUpperCase() === "#DADADA") {
                        labelBriefSetting1[index].title = "Gray";
                        labelBriefSetting1[index].color = "#DADADA";
                        labelBriefSetting1[index].colorCode = "#DADADA";
                        labelBriefSetting1[index].id = "colorBtnTypeElevenBR";
                        labelBriefSetting1[index].inputType = "inputTypeEleven";
                        labelBriefSetting1[index].label = "colorBtnTypeElevenBRText";
                        labelBriefSetting1[index].labelId = labelBriefSetting[index].labelId;
                        labelBriefSetting1[index].labelName = labelBriefSetting[index].labelName;
                        labelBriefSetting1[index].orderIndex = labelBriefSetting[index].orderIndex;
                        setColorBtnTypeElevenBRText(labelBriefSetting[index].labelName);
                    } else if (labelBriefSetting[index].colorCode === "underline") {
                        labelBriefSetting1[index].id = "underLine";
                        labelBriefSetting1[index].title = "Underline";
                        labelBriefSetting1[index].color = "underLine";
                        labelBriefSetting1[index].colorCode = "underLine";
                        labelBriefSetting1[index].inputType = "inputTypeUnderLine";
                        labelBriefSetting1[index].label = "colorBtnTypeUnderLineBRText";
                        labelBriefSetting1[index].labelId = labelBriefSetting[index].labelId;
                        labelBriefSetting1[index].labelName = labelBriefSetting[index].labelName;
                        labelBriefSetting1[index].orderIndex = labelBriefSetting[index].orderIndex;
                        setColorBtnTypeUnderLineBRText(labelBriefSetting[index].labelName);
                    }
                }
            }
        }
        let briefVOList = JSON.parse(localStorage.getItem("briefVOList"));
        if (localStorage.getItem("briefVOList") !== null) {
            if (briefVOList !== null) {
                for (let i = 0; i < briefVOList.length; i++) {
                    labelBriefSetting1 = labelBriefSetting1.filter(entry => entry.color !== briefVOList[i].highlightColorCode);
                }
            }
        }
        setBriefCodeVOListState(labelBriefSetting1);
        hiddenColorBriefList = briefVOList !== null ? [...briefVOList] : [];
        if (hiddenColorBriefList.length !== 0) { setBriefHiddenColorText("Click a color to add it back to your e-book highlighters."); }
        else { setBriefHiddenColorText("There are no hidden highlighters."); }
        for (let index = 0; index < hiddenColorBriefList.length; index++) {
            if (hiddenColorBriefList[index].highlightColorCode === "#EDE48C") {
                hiddenColorBriefList[index].color = "#EDE48C";
                hiddenColorBriefList[index].id = "colorBtnTypeOneBR";
                hiddenColorBriefList[index].inputType = "inputTypeOne";
            } else if (hiddenColorBriefList[index].highlightColorCode === "#B5EB97") {
                hiddenColorBriefList[index].color = "#B5EB97";
                hiddenColorBriefList[index].id = "colorBtnTypeTwoBR";
                hiddenColorBriefList[index].inputType = "inputTypeTwo";
            } else if (hiddenColorBriefList[index].highlightColorCode === "#AEE6FE") {
                hiddenColorBriefList[index].color = "#AEE6FE";
                hiddenColorBriefList[index].id = "colorBtnTypeThreeBR";
                hiddenColorBriefList[index].inputType = "inputTypeThree";
            } else if (hiddenColorBriefList[index].highlightColorCode === "#FEC0FF") {
                hiddenColorBriefList[index].color = "#FEC0FF";
                hiddenColorBriefList[index].id = "colorBtnTypeFourBR";
                hiddenColorBriefList[index].inputType = "inputTypeFour";
            } else if (hiddenColorBriefList[index].highlightColorCode === "#FFD4A8") {
                hiddenColorBriefList[index].color = "#FFD4A8";
                hiddenColorBriefList[index].id = "colorBtnTypeFiveBR";
                hiddenColorBriefList[index].inputType = "inputTypeFive";
            } else if (hiddenColorBriefList[index].highlightColorCode === "#CBBEFC") {
                hiddenColorBriefList[index].color = "#CBBEFC";
                hiddenColorBriefList[index].id = "colorBtnTypeSixBR";
                hiddenColorBriefList[index].inputType = "inputTypeSix";
            } else if (hiddenColorBriefList[index].highlightColorCode === "#35FBE2") {
                hiddenColorBriefList[index].color = "#35FBE2";
                hiddenColorBriefList[index].id = "colorBtnTypeSevenBR";
                hiddenColorBriefList[index].inputType = "inputTypeSeven";
            } else if (hiddenColorBriefList[index].highlightColorCode === "#95A7FF") {
                hiddenColorBriefList[index].color = "#95A7FF";
                hiddenColorBriefList[index].id = "colorBtnTypeEightBR";
                hiddenColorBriefList[index].inputType = "inputTypeEight";
            } else if (hiddenColorBriefList[index].highlightColorCode === "#FF8787") {
                hiddenColorBriefList[index].color = "#FF8787";
                hiddenColorBriefList[index].id = "colorBtnTypeNineBR";
                hiddenColorBriefList[index].inputType = "inputTypeNine";
            } else if (hiddenColorBriefList[index].highlightColorCode === "#C1A88E") {
                hiddenColorBriefList[index].color = "#C1A88E";
                hiddenColorBriefList[index].id = "colorBtnTypeTenBR";
                hiddenColorBriefList[index].inputType = "inputTypeTen";
            } else if (hiddenColorBriefList[index].highlightColorCode === "#DADADA") {
                hiddenColorBriefList[index].color = "#DADADA";
                hiddenColorBriefList[index].id = "colorBtnTypeElevenBR";
                hiddenColorBriefList[index].inputType = "inputTypeEleven";
            } else if (hiddenColorBriefList[index].highlightColorCode === "underLine") {
                hiddenColorBriefList[index].id = "underLine";
                hiddenColorBriefList[index].color = "underLine";
                hiddenColorBriefList[index].inputType = "inputTypeUnderLine";
            }
        }
        setHiddenColorBriefListState(hiddenColorBriefList);
        let userSettingsVO = JSON.parse(localStorage.getItem("userSettingsVO"));
        if (userSettingsVO !== null) {
            if (parseInt(userSettingsVO[0].prefferedFontSize) >= 12 && userSettingsVO[0].prefferedFontSize !== undefined && userSettingsVO[0].prefferedFontSize !== null) {
                setFontSize(userSettingsVO[0].prefferedFontSize);
                setLineHeight(userSettingsVO[0].prefferedLineSpacing);
                updateFontSetting();
            }
        }
    }
    const deleteColorSelectionPalate1 = (e, newcolor) => {
        let colorBtId = e.currentTarget.id;
        if (colorBtId === "underLine") { setState({ underLineSt: false }); }
        else {
            if (colorBtId === "colorBtnTypeOne1") { setState({ colorBtnTypeOne1: false }) }
            else if (colorBtId === "colorBtnTypeTwo1") { setState({ colorBtnTypeTwo1: false }) }
            else if (colorBtId === "colorBtnTypeThree1") { setState({ colorBtnTypeThree1: false }) }
            else if (colorBtId === "colorBtnTypeFour1") { setState({ colorBtnTypeFour1: false }) }
            else if (colorBtId === "colorBtnTypeFive1") { setState({ colorBtnTypeFive1: false }) }
            else if (colorBtId === "colorBtnTypeSix1") { setState({ colorBtnTypeSix1: false }) }
            else if (colorBtId === "colorBtnTypeSeven1") { setState({ colorBtnTypeSeven1: false }) }
            else if (colorBtId === "colorBtnTypeEight1") { setState({ colorBtnTypeEight1: false }) }
            else if (colorBtId === "colorBtnTypeNine1") { setState({ colorBtnTypeNine1: false }) }
            else if (colorBtId === "colorBtnTypeTen1") { setState({ colorBtnTypeTen1: false }) }
            else if (colorBtId === "colorBtnTypeEleven1") { setState({ colorBtnTypeEleven1: false }) }
        }
        if (document.querySelector("[colorcode='" + newcolor + "']")) {
            if (newcolor === 'underLine') { }
            else {
                let colorBT = document.getElementById(colorBtId);
                colorBT.remove();
                let button = document.createElement("BUTTON");
                button.id = colorBtId;
                button.className = "colorPalateBtn";
                button.setAttribute('style', 'background-color:' + newcolor);
                document.getElementById('eBookColorPalateContainerSelection').appendChild(button);
            }
            if (document.getElementById(colorBtId) !== null) {
                document.getElementById(colorBtId).addEventListener('click', function (e) { colorSelectionPalate1(e, newcolor); });
            }
        }
        updateHiddenColorsMsg("content");
    }
    const saveColorChanges = (e) => {
        setLoadSpin(true); selectedColorList = [];
        setSaveBtnAriaLabel('Saving highlighter settings');
        let i = document.getElementById('eBookColorPalateContainerHidden');
        let ele = i.childNodes;
        ele.forEach(function (item) { selectedColorList.push(item.getAttribute('colorcode')); });
        selectedColorList = (selectedColorList.length === 0) ? [] : [...new Set(selectedColorList)];
        let bookVO1 = JSON.parse(localStorage.getItem("bookVO"));
        let reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "userRoleId": userVO.userRoleId,
                "userActivityVO": {
                    "lastReadSectionId": "",
                    "lastViewedOutlineId": "",
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                    "lastReadParagraphId": "para01",
                    "lastReadBookId": bookVO1.bookId,
                    "lastReadSubSectionId": "subsec01",
                    "lastReadChapterId": bookVO1.chapterId,
                    "lastReadPageNum": bookVO1.lastReadPageNum,
                },
                "sessionVO": getSessionVO()
            },
            "annotationVO": {
                "userId": userVO.userId,
                "bookId": bookVO1.bookId,
                "chapterId": bookVO1.chapterId,
                "highlightColorCodeList": selectedColorList
            }
        };
        const requestOptions1 = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        };
        fetch(`${localStorage.getItem('ENV')}/bookContentRetrievalService/saveUserHighlightSettings`, requestOptions1)
            .then(response => response.json())
            .then(data => {
                if (data.status === "true") {
                    let reqData = {
                        "userVO": {
                            "userId": userVO.userId,
                            "userRole": userVO.userRole,
                            "userRoleId": userVO.userRoleId,
                            "userActivityVO": {
                                "lastReadSectionId": "",
                                "lastViewedOutlineId": "",
                                "lastActivityCode": "BOOKSHELF",
                                "pageNavigatingFrom": "EReader",
                                "pageNavigatingTo": "Bookshelf",
                                "lastReadParagraphId": "para01",
                                "lastReadBookId": bookVO1.bookId,
                                "lastReadSubSectionId": "subsec01",
                                "lastReadChapterId": bookVO1.chapterId,
                                "lastReadPageNum": bookVO1.lastReadPageNum,
                            },
                            "sessionVO": getSessionVO()
                        },
                        "bookVO": { "bookId": bookVO1.bookId }
                    };
                    const requestOptions1 = {
                        method: 'POST',
                        body: JSON.stringify(reqData),
                        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                    };
                    fetch(`${localStorage.getItem('ENV')}/bookContentRetrievalService/getUserHighlightAndBriefSettings`, requestOptions1)
                        .then(response => response.json())
                        .then(data => {
                            if (data.status === "true") {
                                let annotationVOList = data.annotationVOList;
                                if (annotationVOList) {
                                    annotationVOList = Array.isArray(annotationVOList) ? annotationVOList : [annotationVOList];
                                    dispatch(setRemovedColorsVOList(annotationVOList));
                                    localStorage.setItem("colorCodeVOList", JSON.stringify(annotationVOList));
                                    setHiddenColorText("Click a color to add it back to your e-book highlighters.");
                                } else {
                                    dispatch(setRemovedColorsVOList(null));
                                    localStorage.removeItem("colorCodeVOList");
                                    setHiddenColorText("There are no hidden highlighters.");
                                }
                                setEditHighlighterOpen(false);
                                setHighlighterPopoverSave(false);
                                setTimeout(() => { $('a#collasible-setting-dropdown.dropdown-toggle.nav-link').focus(); }, 200);
                                getLatestHighlights();
                            } else if (data.wkErrorCode) {
                                handleException(data);
                            }
                            setLoadSpin(false);
                        }).catch(error => {
                            console.error("There has been a problem with your fetch operation:", error);
                        });
                } else if (data.wkErrorCode) {
                    handleException(data);
                }
                setLoadSpin(false);
            }).catch(error => {
                setLoadSpin(false);
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    const colorSelectionPalate1 = (e, newcolor) => {
        let colorID = e.currentTarget.id;
        if (colorID === "underLine") {
            setState({ underLineSt: true });
            setState({ underLineStHidden: true });
        }
        else {
            if (colorID === "colorBtnTypeOne1") { setState({ colorBtnTypeOne1: true }) }
            else if (colorID === "colorBtnTypeTwo1") { setState({ colorBtnTypeTwo1: true }) }
            else if (colorID === "colorBtnTypeThree1") { setState({ colorBtnTypeThree1: true }) }
            else if (colorID === "colorBtnTypeFour1") { setState({ colorBtnTypeFour1: true }) }
            else if (colorID === "colorBtnTypeFive1") { setState({ colorBtnTypeFive1: true }) }
            else if (colorID === "colorBtnTypeSix1") { setState({ colorBtnTypeSix1: true }) }
            else if (colorID === "colorBtnTypeSeven1") { setState({ colorBtnTypeSeven1: true }) }
            else if (colorID === "colorBtnTypeEight1") { setState({ colorBtnTypeEight1: true }) }
            else if (colorID === "colorBtnTypeNine1") { setState({ colorBtnTypeNine1: true }) }
            else if (colorID === "colorBtnTypeTen1") { setState({ colorBtnTypeTen1: true }) }
            else if (colorID === "colorBtnTypeEleven1") { setState({ colorBtnTypeEleven1: true }) }
        }
        if (document.querySelector("[colorcode='" + newcolor + "']")) {
            if (newcolor === 'underLine') { }
            else {
                let colorBT = document.getElementById(colorID);
                colorBT.remove();
                let button = document.createElement("BUTTON");
                button.id = colorID;
                button.className = "colorPalateBtn";
                button.setAttribute('colorcode', newcolor);
                button.setAttribute('style', 'background-color:' + newcolor);
                document.getElementById('eBookColorPalateContainerHidden').appendChild(button);
            }
        }
        if (document.getElementById(colorID) !== null) {
            document.getElementById(colorID).addEventListener('click', function (e) { deleteColorSelectionPalate1(e, newcolor); });
        }
        updateHiddenColorsMsg("content");
    }
    const colorSelectionPalateBR = (e, newcolor) => {
        let colorID = e.currentTarget.id;
        if (colorID === "underLine") { setState({ colorBtnTypeUnderLineBR: true }); }
        else {
            ReactDOM.render(<GrFormClose className="settingSelectedColor" style={{ left: colorID.offsetLeft - 8 + "px" }} />, document.getElementById(colorID));
            if (colorID === "colorBtnTypeOneBR") { setState({ colorBtnTypeOneBR: true }) }
            else if (colorID === "colorBtnTypeTwoBR") { setState({ colorBtnTypeTwoBR: true }) }
            else if (colorID === "colorBtnTypeThreeBR") { setState({ colorBtnTypeThreeBR: true }) }
            else if (colorID === "colorBtnTypeFourBR") { setState({ colorBtnTypeFourBR: true }) }
            else if (colorID === "colorBtnTypeFiveBR") { setState({ colorBtnTypeFiveBR: true }) }
            else if (colorID === "colorBtnTypeSixBR") { setState({ colorBtnTypeSixBR: true }) }
            else if (colorID === "colorBtnTypeSevenBR") { setState({ colorBtnTypeSevenBR: true }) }
            else if (colorID === "colorBtnTypeEightBR") { setState({ colorBtnTypeEightBR: true }) }
            else if (colorID === "colorBtnTypeNineBR") { setState({ colorBtnTypeNineBR: true }) }
            else if (colorID === "colorBtnTypeTenBR") { setState({ colorBtnTypeTenBR: true }) }
            else if (colorID === "colorBtnTypeElevenBR") { setState({ colorBtnTypeElevenBR: true }) }
        }
        if (document.querySelector("#caseBriefColorPalateContainer [colorcode='" + newcolor + "']")) {
            if (newcolor === 'underLine') { }
            else {
                let colorBT = document.getElementById(colorID);
                colorBT.parentNode.remove();
                let button = document.createElement("BUTTON");
                button.id = colorID;
                button.className = "colorPalateBtn";
                button.setAttribute('colorCode', newcolor);
                button.setAttribute('style', 'background-color:' + newcolor);
                document.querySelector('#caseBriefColorPalateContainerHidden .caseBrief_colorPalateContainer').appendChild(button);
                if (document.getElementById(colorID) !== null) {
                    document.getElementById(colorID).addEventListener('click', function (e) {
                        if (document.querySelector("[colorcode='" + newcolor + "']")) {
                            deleteColorSelectionPalateBR(e, newcolor);
                        }
                    });
                }
            }
            updateHiddenColorsMsg("case");
        }
    }
    const deleteColorSelectionPalateBR = (e, newcolor) => {
        let colorBtId = e.currentTarget.id;
        if (colorBtId === "underLine") { setState({ colorBtnTypeUnderLineBR: false }); }
        else {
            if (colorBtId === "colorBtnTypeOneBR") { setState({ colorBtnTypeOneBR: false }); }
            else if (colorBtId === "colorBtnTypeTwoBR") { setState({ colorBtnTypeTwoBR: false }); }
            else if (colorBtId === "colorBtnTypeThreeBR") { setState({ colorBtnTypeThreeBR: false }); }
            else if (colorBtId === "colorBtnTypeFourBR") { setState({ colorBtnTypeFourBR: false }); }
            else if (colorBtId === "colorBtnTypeFiveBR") { setState({ colorBtnTypeFiveBR: false }); }
            else if (colorBtId === "colorBtnTypeSixBR") { setState({ colorBtnTypeSixBR: false }); }
            else if (colorBtId === "colorBtnTypeSevenBR") { setState({ colorBtnTypeSevenBR: false }); }
            else if (colorBtId === "colorBtnTypeEightBR") { setState({ colorBtnTypeEightBR: false }); }
            else if (colorBtId === "colorBtnTypeNineBR") { setState({ colorBtnTypeNineBR: false }); }
            else if (colorBtId === "colorBtnTypeTenBR") { setState({ colorBtnTypeTenBR: false }); }
            else if (colorBtId === "colorBtnTypeElevenBR") { setState({ colorBtnTypeElevenBR: false }); }
        }
        if (document.querySelector("[colorcode='" + newcolor + "']")) {
            if (newcolor === 'underLine') { }
            else {
                let colorBT = document.getElementById(colorBtId);
                colorBT.remove();
                let briefColorContainer = document.createElement("div");
                briefColorContainer.setAttribute('class', "briefColorContainer_rt");
                let button = document.createElement("BUTTON");
                button.id = colorBtId;
                button.className = "colorPalateBtn";
                button.setAttribute('colorcode', newcolor);
                button.setAttribute('style', 'background-color:' + newcolor);
                briefColorContainer.appendChild(button);
                let input = document.createElement("input");
                for (var i = 0; i < labelSettingsVOList.length; i++) {
                    if (labelSettingsVOList[i].colorCode.toLowerCase() === newcolor.toLowerCase()) {
                        input.value = labelSettingsVOList[i].labelName
                    }
                }
                if (colorBtId === "colorBtnTypeOneBR") {
                    input.id = "inputTypeOne"; input.setAttribute('name', 'colorBtnTypeOneBRText');
                } else if (colorBtId === "colorBtnTypeTwoBR") {
                    input.id = "inputTypeTwo"; input.setAttribute('name', 'colorBtnTypeTwoBRText');
                } else if (colorBtId === "colorBtnTypeThreeBR") {
                    input.id = "inputTypeThree"; input.setAttribute('name', 'colorBtnTypeThreeBRText');
                } else if (colorBtId === "colorBtnTypeFourBR") {
                    input.id = "inputTypeFour"; input.setAttribute('name', 'colorBtnTypeFourBRText');
                } else if (colorBtId === "colorBtnTypeFiveBR") {
                    input.id = "inputTypeFive"; input.setAttribute('name', 'colorBtnTypeFiveBRText');
                } else if (colorBtId === "colorBtnTypeSixBR") {
                    input.id = "inputTypeSix"; input.setAttribute('name', 'colorBtnTypeSixBRText');
                } else if (colorBtId === "colorBtnTypeSevenBR") {
                    input.id = "inputTypeSeven"; input.setAttribute('name', 'colorBtnTypeSevenBRText');
                } else if (colorBtId === "colorBtnTypeEightBR") {
                    input.id = "inputTypeEight"; input.setAttribute('name', 'colorBtnTypeEightBRText');
                } else if (colorBtId === "colorBtnTypeNineBR") {
                    input.id = "inputTypeNine"; input.setAttribute('name', 'colorBtnTypeNineBRText');
                } else if (colorBtId === "colorBtnTypeTenBR") {
                    input.id = "inputTypeTen"; input.setAttribute('name', 'colorBtnTypeTenBRText');
                } else if (colorBtId === "colorBtnTypeElevenBR") {
                    input.id = "inputTypeEleven"; input.setAttribute('name', 'colorBtnTypeElevenBRText');
                }
                input.setAttribute('type', 'text');
                briefColorContainer.appendChild(input);
                document.querySelector('#caseBriefColorPalateContainer .caseBrief_colorPalateContainer').appendChild(briefColorContainer);
            }
            if (document.getElementById(colorBtId) !== null) {
                document.getElementById(colorBtId).addEventListener('click', function (e) {
                    colorSelectionPalateBR(e, newcolor);
                });
            }
        }
        updateHiddenColorsMsg("case");
    }
    const saveLabelSettings = (e) => {
        setLoadSpin(true);
        setSaveBtnAriaLabel('Saving highlighter settings');
        labelVOListLocal = [];
        let labelele = document.querySelector('#caseBriefColorPalateContainer .caseBrief_colorPalateContainer').childNodes;
        labelele.forEach(function (item, index) {
            var obj = {
                "labelName": labelele[index].children[1].value,
                "orderIndex": labelele[index].children[0].getAttribute('orderIndex'),
                "colorCode": labelele[index].children[0].getAttribute('colorcode').toLowerCase(),
            };
            labelVOListLocal.push(obj);
        });
        var updatedLabelVOList = [];
        if (labelSettingsVOList) {
            var flag = false;
            for (var i = 0; i < labelSettingsVOList.length; i++) {
                flag = false;
                for (var j = 0; j < labelVOListLocal.length; j++) {
                    if (labelSettingsVOList[i].colorCode.toLowerCase() === labelVOListLocal[j].colorCode.toLowerCase()) {
                        flag = true;
                        var temp = JSON.parse(JSON.stringify(labelSettingsVOList[i]));
                        temp.labelName = labelVOListLocal[j].labelName;
                        updatedLabelVOList.push(temp);
                    }
                }
                if (!flag) { updatedLabelVOList.push(labelSettingsVOList[i]); }
            }
        }
        labelVOListLocal = updatedLabelVOList;
        let bookVO1 = JSON.parse(localStorage.getItem("bookVO"));
        let reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "userRoleId": userVO.userRoleId,
                "streamContentRequiredFlag": false,
                "userActivityVO": {
                    "lastReadSectionId": "",
                    "lastViewedOutlineId": "",
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                    "lastReadParagraphId": "para01",
                    "lastReadBookId": bookVO1.bookId,
                    "lastReadSubSectionId": "subsec01",
                    "lastReadChapterId": bookVO1.chapterId,
                    "lastReadPageNum": bookVO1.lastReadPageNum,
                },
                "sessionVO": getSessionVO()
            },
            "labelVOList": labelVOListLocal,
            "bookVO": { "bookId": bookVO1.bookId },
        };
        const requestOptions1 = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        };
        fetch(`${localStorage.getItem('ENV')}/manageCases/saveLabelSettings`, requestOptions1)
            .then(response => response.json())
            .then(data => {
                if (data.status === "true") {
                    selectedColorBriefList = [];
                    let labelVOList = data.labelVOList;
                    if (labelVOList) { labelVOList = Array.isArray(labelVOList) ? labelVOList : [labelVOList]; }
                    dispatch(setLabelSettingsVOList(Array.isArray(labelVOList) ? labelVOList : [labelVOList]))
                    localStorage.setItem("labelVOList", JSON.stringify(labelVOList));
                    let i = document.querySelector('#caseBriefColorPalateContainerHidden .caseBrief_colorPalateContainer')
                    let ele = i.childNodes;
                    ele.forEach(function (item) { if (item.getAttribute('colorcode') !== "") { selectedColorBriefList.push(item.getAttribute('colorcode')); } });
                    selectedColorBriefList = selectedColorBriefList.filter((v, i, a) => a.indexOf(v) === i);
                    selectedColorBriefList = selectedColorBriefList.length === 0 ? [] : selectedColorBriefList;
                    let bookVO1 = JSON.parse(localStorage.getItem("bookVO"));
                    let reqData1 = {
                        "userVO": {
                            "userId": userVO.userId,
                            "userRole": userVO.userRole,
                            "userRoleId": userVO.userRoleId,
                            "userActivityVO": {
                                "lastReadSectionId": "",
                                "lastViewedOutlineId": "",
                                "lastActivityCode": "BOOKSHELF",
                                "pageNavigatingFrom": "EReader",
                                "pageNavigatingTo": "Bookshelf",
                                "lastReadParagraphId": "para01",
                                "lastReadBookId": bookVO1.bookId,
                                "lastReadSubSectionId": "subsec01",
                                "lastReadChapterId": bookVO1.chapterId,
                                "lastReadPageNum": bookVO1.lastReadPageNum,
                            },
                            "bookId": bookVO1.bookId,
                            "sessionVO": getSessionVO(),
                        },
                        "briefVO": { "highlightColorCodeList": selectedColorBriefList }
                    };
                    const requestOptions1 = {
                        method: 'POST',
                        body: JSON.stringify(reqData1),
                        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                    };
                    fetch(`${localStorage.getItem('ENV')}/bookContentRetrievalService/saveUserBriefSettings`, requestOptions1)
                        .then(response => response.json())
                        .then(data => {
                            if (data.status === "true") {
                                dispatch(setRemovedLabelVOList(Array.isArray(selectedColorBriefList) ? selectedColorBriefList : [selectedColorBriefList]));
                                let reqData = {
                                    "userVO": {
                                        "userId": userVO.userId,
                                        "userRole": userVO.userRole,
                                        "userRoleId": userVO.userRoleId,
                                        "userActivityVO": {
                                            "lastReadSectionId": "",
                                            "lastViewedOutlineId": "",
                                            "lastActivityCode": "BOOKSHELF",
                                            "pageNavigatingFrom": "EReader",
                                            "pageNavigatingTo": "Bookshelf",
                                            "lastReadParagraphId": "para01",
                                            "lastReadBookId": bookVO1.bookId,
                                            "lastReadSubSectionId": "subsec01",
                                            "lastReadChapterId": bookVO1.chapterId,
                                            "lastReadPageNum": bookVO1.lastReadPageNum,
                                        },
                                        "sessionVO": getSessionVO()
                                    },
                                    "bookVO": { "bookId": bookVO1.bookId }
                                };
                                const requestOptions1 = {
                                    method: 'POST',
                                    body: JSON.stringify(reqData),
                                    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                                };
                                fetch(`${localStorage.getItem('ENV')}/bookContentRetrievalService/getUserHighlightAndBriefSettings`, requestOptions1)
                                    .then(response => response.json())
                                    .then(data => {
                                        if (data.status === "true") {
                                            setBriefOpen(false);
                                            setBriefPopoverSave(false);
                                            setTimeout(() => { $('a#collasible-setting-dropdown.dropdown-toggle.nav-link').focus(); }, 200);
                                            let briefVOList = data.briefVOList;
                                            if (briefVOList) {
                                                briefVOList = Array.isArray(briefVOList) ? briefVOList : [briefVOList];
                                                dispatch(setRemovedColorsVOList(briefVOList));
                                                localStorage.setItem("briefVOList", JSON.stringify(briefVOList));
                                                setBriefHiddenColorText("Click a color to add it back to your case brief highlighters.");
                                            } else {
                                                dispatch(setRemovedColorsVOList(null));
                                                localStorage.removeItem("briefVOList");
                                                setBriefHiddenColorText("There are no hidden highlighters.");
                                            }
                                        } else if (data.wkErrorCode) {
                                            handleException(data);
                                        }
                                        setLoadSpin(false);
                                    }).catch(error => {
                                        setLoadSpin(false);
                                        console.error("There has been a problem with your fetch operation:", error);
                                    });
                            } else if (data.wkErrorCode) {
                                handleException(data);
                            }
                        }).catch(error => {
                            setLoadSpin(false);
                            console.error("There has been a problem with your fetch operation:", error);
                        });
                } else if (data.wkErrorCode) {
                    handleException(data);
                }
                setLoadSpin(false);
            }).catch(error => {
                setLoadSpin(false);
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    const handleBriefLabelName = (e) => {
        const { name, value, id } = e.target;
        if (name === "colorBtnTypeOneBRText") {
            setColorBtnTypeOneBRText(value);
        } else if (name === "colorBtnTypeTwoBRText") {
            setColorBtnTypeTwoBRText(value);
        } else if (name === "colorBtnTypeThreeBRText") {
            setColorBtnTypeThreeBRText(value);
        } else if (name === "colorBtnTypeFourBRText") {
            setColorBtnTypeFourBRText(value);
        } else if (name === "colorBtnTypeFiveBRText") {
            setColorBtnTypeFiveBRText(value);
        } else if (name === "colorBtnTypeSixBRText") {
            setColorBtnTypeSixBRText(value);
        } else if (name === "colorBtnTypeSevenBRText") {
            setColorBtnTypeSevenBRText(value);
        } else if (name === "colorBtnTypeEightBRText") {
            setColorBtnTypeEightBRText(value);
        } else if (name === "colorBtnTypeNineBRText") {
            setColorBtnTypeNineBRText(value);
        } else if (name === "colorBtnTypeTenBRText") {
            setColorBtnTypeTenBRText(value);
        } else if (name === "colorBtnTypeElevenBRText") {
            setColorBtnTypeElevenBRText(value);
        } else if (name === "underLine") {
            setColorBtnTypeUnderLineBRText(value);
        }
    }
    const saveEbookStyle = (isUpdateFontSetting = true) => {
        let bookVO1 = JSON.parse(localStorage.getItem("bookVO"));
        localStorage.setItem("userBookFontSize", isUpdateFontSetting ? fontSize : "");
        localStorage.setItem("userBookLineHeight", isUpdateFontSetting ? lineHeight : "");
        var reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "userRoleId": userVO.userRoleId,
                "userActivityVO": {
                    "lastViewedOutlineId": "",
                    "pageNavigatingTo": "EReader",
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "lastReadParagraphId": "para01",
                    "lastReadBookId": bookVO1.bookId,
                    "lastReadSubSectionId": "subsec01",
                    "lastReadSectionId": bookVO1.chapterId,
                    "lastReadPageNum": bookVO1.lastReadPageNum,
                    "lastReadChapterId": bookVO1.lastReadPageNum,
                },
                "sessionVO": getSessionVO()
            },
            "userSettingsVOList": [{
                "userId": userVO.userId,
                "createdBy": userVO.userId,
                "modifiedBy": userVO.userId,
                "userRole": userVO.userRole,
                "prefferedHighlightColor": '',
                "userRoleId": userVO.userRoleId,
                "noteConfirmationDisplayCount": "2",
                "prefferedFontStyle": "Times New Roman",
                "prefferedFontSize": isUpdateFontSetting ? fontSize : "0",
                "prefferedLineSpacing": isUpdateFontSetting ? lineHeight : "0",
            }]
        };
        const requestOptions1 = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        };
        fetch(`${localStorage.getItem('ENV')}/manageUserService/saveUserSettings`, requestOptions1)
            .then(response => response.json())
            .then(data => {
                if (data.status === "true") {
                    if (isUpdateFontSetting) { updateFontSetting(); }
                    hideEBookStyleModal(); revertStyleFlag = false;
                    setTimeout(() => { reCalculateNotesOnRight(); reCalculateBriefOnRight(); }, 2000);
                } else if (data.wkErrorCode) {
                    handleException(data);
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    const updateFontSetting = () => {
        let contentClass = "#ereaderBookContentContainer", i, j;
        if (lineHeight === "12") j = "1.2";
        else if (lineHeight === "15") j = "1.8";
        else if (lineHeight === "20") j = "2.4";
        if (fontSize === "12") {
            $(".ccapp-chunkHeader").css({ "font-size": "200%", "line-height": "120%" });
            $(contentClass + " div:not([cc-font-xxsmall]) p").css({ "font-size": "12px", "line-height": j });
            $(contentClass + " div:not([cc-font-xsmall]) p").css({ "font-size": "12px", "line-height": j });
            $(contentClass + " div:not([cc-font-small]) p").css({ "font-size": "12px", "line-height": j });
            $(contentClass + " div:not([cc-font-medium]) p").css({ "font-size": "12px", "line-height": j });
            $(contentClass + " div:not([cc-font-large]) p").css({ "font-size": "12px", "line-height": j });
            $(contentClass + " div:not([cc-font-xlarge]) p").css({ "font-size": "12px", "line-height": j });
            $(contentClass).find(".cc-font-xxsmall p").css("font-size", "11px");
            $(contentClass).find(".cc-font-xsmall p").css("font-size", "12px");
            $(contentClass).find(".cc-font-xsmall").css("font-size", "12px");
            $(contentClass).find(".cc-font-small p").css("font-size", "14px");
            $(contentClass).find(".cc-font-small").css("font-size", "14px");
            $(contentClass).find("#notes-container .notesText").css({ "font-size": "14px", "line-height": j });
            $(contentClass).find("#notes-container .labelNoteWrapper").css({ "font-size": "14px", "line-height": j });
            $(contentClass).find(".cc-font-medium h3 p").css({ "font-size": "14px", "line-height": j });
            $(contentClass).find(".cc-font-medium").css({ "font-size": "14px", "line-height": j });
            $(contentClass).find(".cc-font-large p").css({ "font-size": "14px", "line-height": j });
            $(contentClass).find(".cc-font-large").css({ "font-size": "14px", "line-height": j });
            $(contentClass).find(".cc-font-xlarge").css({ "font-size": "16px", "line-height": j });
            $(contentClass).find(".cc-font-xlarge h2 p").css({ "font-size": "16px", "line-height": j });
            $(contentClass).find(".cc-font-xlarge h3 p").css({ "font-size": "16px", "line-height": j });
            $(contentClass).find(".cc-chapter-title h1 p").css({ "font-size": "22px", "line-height": j });
            $(contentClass).find(".cc-chapter-title").css({ "font-size": "22px", "line-height": j });
        } else if (fontSize === "14") {
            $(".ccapp-chunkHeader").css({ "font-size": "200%", "line-height": "120%" });
            $(contentClass + " div:not([cc-font-xxsmall]) p").css({ "font-size": "14px", "line-height": j });
            $(contentClass + " div:not([cc-font-xsmall]) p").css({ "font-size": "14px", "line-height": j });
            $(contentClass + " div:not([cc-font-small]) p").css({ "font-size": "14px", "line-height": j });
            $(contentClass + " div:not([cc-font-medium]) p").css({ "font-size": "14px", "line-height": j });
            $(contentClass + " div:not([cc-font-large]) p").css({ "font-size": "14px", "line-height": j });
            $(contentClass + " div:not([cc-font-xlarge]) p").css({ "font-size": "14px", "line-height": j });
            $(contentClass).find(".cc-font-xxsmall p").css("font-size", "12px");
            $(contentClass).find(".cc-font-xsmall p").css("font-size", "14px");
            $(contentClass).find(".cc-font-xsmall").css("font-size", "14px");
            $(contentClass).find(".cc-font-small p").css("font-size", "16px");
            $(contentClass).find(".cc-font-small").css("font-size", "16px");
            $(contentClass).find("#notes-container .notesText").css({ "font-size": "16px", "line-height": j });
            $(contentClass).find("#notes-container .labelNoteWrapper").css({ "font-size": "16px", "line-height": j });
            $(contentClass).find(".cc-font-medium h3 p").css({ "font-size": "16px", "line-height": j });
            $(contentClass).find(".cc-font-medium").css({ "font-size": "16px", "line-height": j });
            $(contentClass).find(".cc-font-large p").css({ "font-size": "16px", "line-height": j });
            $(contentClass).find(".cc-font-large").css({ "font-size": "16px", "line-height": j });
            $(contentClass).find(".cc-font-xlarge").css({ "font-size": "18px", "line-height": j });
            $(contentClass).find(".cc-font-xlarge h2 p").css({ "font-size": "18px", "line-height": j });
            $(contentClass).find(".cc-font-xlarge h3 p").css({ "font-size": "18px", "line-height": j });
            $(contentClass).find(".cc-chapter-title h1 p").css({ "font-size": "24px", "line-height": j });
            $(contentClass).find(".cc-chapter-title").css({ "font-size": "24px", "line-height": j });
        } else if (fontSize === "16") {
            $(".ccapp-chunkHeader").css({ "font-size": "200%", "line-height": "120%" });
            $(contentClass + " div:not([cc-font-xxsmall]) p").css({ "font-size": "16px", "line-height": j });
            $(contentClass + " div:not([cc-font-xsmall]) p").css({ "font-size": "16px", "line-height": j });
            $(contentClass + " div:not([cc-font-small]) p").css({ "font-size": "16px", "line-height": j });
            $(contentClass + " div:not([cc-font-medium]) p").css({ "font-size": "16px", "line-height": j });
            $(contentClass + " div:not([cc-font-large]) p").css({ "font-size": "16px", "line-height": j });
            $(contentClass + " div:not([cc-font-xlarge]) p").css({ "font-size": "16px", "line-height": j });
            $(contentClass).find(".cc-font-xxsmall p").css("font-size", "14px");
            $(contentClass).find(".cc-font-xsmall p").css("font-size", "16px");
            $(contentClass).find(".cc-font-xsmall").css("font-size", "16px");
            $(contentClass).find(".cc-font-small p").css("font-size", "18px");
            $(contentClass).find(".cc-font-small").css("font-size", "18px");
            $(contentClass).find("#notes-container .notesText").css({ "font-size": "22px", "line-height": j });
            $(contentClass).find("#notes-container .labelNoteWrapper").css({ "font-size": "22px", "line-height": j });
            $(contentClass).find(".cc-font-medium h3 p").css({ "font-size": "22px", "line-height": j });
            $(contentClass).find(".cc-font-medium").css({ "font-size": "22px", "line-height": j });
            $(contentClass).find(".cc-font-large p").css({ "font-size": "22px", "line-height": j });
            $(contentClass).find(".cc-font-large").css({ "font-size": "22px", "line-height": j });
            $(contentClass).find(".cc-font-xlarge").css({ "font-size": "24px", "line-height": j });
            $(contentClass).find(".cc-font-xlarge h2 p").css({ "font-size": "24px", "line-height": j });
            $(contentClass).find(".cc-font-xlarge h3 p").css({ "font-size": "24px", "line-height": j });
            $(contentClass).find(".cc-chapter-title h1 p").css({ "font-size": "30px", "line-height": j });
            $(contentClass).find(".cc-chapter-title").css({ "font-size": "30px", "line-height": j });
        } else if (fontSize === "18") {
            $(".ccapp-chunkHeader").css({ "font-size": "200%", "line-height": "120%" });
            $(contentClass + " div:not([cc-font-xxsmall]) p").css({ "font-size": "18px", "line-height": j });
            $(contentClass + " div:not([cc-font-xsmall]) p").css({ "font-size": "18px", "line-height": j });
            $(contentClass + " div:not([cc-font-small]) p").css({ "font-size": "18px", "line-height": j });
            $(contentClass + " div:not([cc-font-medium]) p").css({ "font-size": "18px", "line-height": j });
            $(contentClass + " div:not([cc-font-large]) p").css({ "font-size": "18px", "line-height": j });
            $(contentClass + " div:not([cc-font-xlarge]) p").css({ "font-size": "18px", "line-height": j });
            $(contentClass).find(".cc-font-xxsmall p").css("font-size", "16px");
            $(contentClass).find(".cc-font-xsmall p").css("font-size", "18px");
            $(contentClass).find(".cc-font-xsmall").css("font-size", "18px");
            $(contentClass).find(".cc-font-small p").css("font-size", "22px");
            $(contentClass).find(".cc-font-small").css("font-size", "22px");
            $(contentClass).find("#notes-container .notesText").css({ "font-size": "24px", "line-height": j });
            $(contentClass).find("#notes-container .labelNoteWrapper").css({ "font-size": "24px", "line-height": j });
            $(contentClass).find(".cc-font-medium h3 p").css({ "font-size": "24px", "line-height": j });
            $(contentClass).find(".cc-font-medium").css({ "font-size": "24px", "line-height": j });
            $(contentClass).find(".cc-font-large p").css({ "font-size": "24px", "line-height": j });
            $(contentClass).find(".cc-font-large").css({ "font-size": "24px", "line-height": j });
            $(contentClass).find(".cc-font-xlarge").css({ "font-size": "30px", "line-height": j });
            $(contentClass).find(".cc-font-xlarge h2 p").css({ "font-size": "30px", "line-height": j });
            $(contentClass).find(".cc-font-xlarge h3 p").css({ "font-size": "30px", "line-height": j });
            $(contentClass).find(".cc-chapter-title h1 p").css({ "font-size": "36px", "line-height": j });
            $(contentClass).find(".cc-chapter-title").css({ "font-size": "36px", "line-height": j });
        } else if (fontSize === "20") {
            $(".ccapp-chunkHeader").css({ "font-size": "200%", "line-height": "120%" });
            $(contentClass + " div:not([cc-font-xxsmall]) p").css({ "font-size": "20px", "line-height": j });
            $(contentClass + " div:not([cc-font-xsmall]) p").css({ "font-size": "20px", "line-height": j });
            $(contentClass + " div:not([cc-font-small]) p").css({ "font-size": "20px", "line-height": j });
            $(contentClass + " div:not([cc-font-medium]) p").css({ "font-size": "20px", "line-height": j });
            $(contentClass + " div:not([cc-font-large]) p").css({ "font-size": "20px", "line-height": j });
            $(contentClass + " div:not([cc-font-xlarge]) p").css({ "font-size": "20px", "line-height": j });
            $(contentClass).find(".cc-font-xxsmall p").css("font-size", "18px");
            $(contentClass).find(".cc-font-xsmall p").css("font-size", "22px");
            $(contentClass).find(".cc-font-xsmall").css("font-size", "22px");
            $(contentClass).find(".cc-font-small p").css("font-size", "24px");
            $(contentClass).find(".cc-font-small").css("font-size", "24px");
            $(contentClass).find("#notes-container .notesText").css({ "font-size": "30px", "line-height": j });
            $(contentClass).find("#notes-container .labelNoteWrapper").css({ "font-size": "30px", "line-height": j });
            $(contentClass).find(".cc-font-medium h3 p").css({ "font-size": "30px", "line-height": j });
            $(contentClass).find(".cc-font-medium").css({ "font-size": "30px", "line-height": j });
            $(contentClass).find(".cc-font-large p").css({ "font-size": "30px", "line-height": j });
            $(contentClass).find(".cc-font-large").css({ "font-size": "30px", "line-height": j });
            $(contentClass).find(".cc-font-xlarge").css({ "font-size": "36px", "line-height": j });
            $(contentClass).find(".cc-font-xlarge h2 p").css({ "font-size": "36px", "line-height": j });
            $(contentClass).find(".cc-font-xlarge h3 p").css({ "font-size": "36px", "line-height": j });
            $(contentClass).find(".cc-chapter-title h1 p").css({ "font-size": "42px", "line-height": j });
            $(contentClass).find(".cc-chapter-title").css({ "font-size": "42px", "line-height": j });
        }
    }
    const revertToDefaultStyleOld = (e) => {
        revertStyleFlag = true;
        setFontSize("14");
        setLineHeight("12");
        saveEbookStyle(false);
        let contentClass = "#ereaderBookContentContainer", j = "1.2";
        $(".ccapp-chunkHeader").css({ "font-size": "200%", "line-height": "120%" });
        $(contentClass + " div:not([cc-font-xxsmall]) p").css({ "font-size": "14px", "line-height": j });
        $(contentClass + " div:not([cc-font-xsmall]) p").css({ "font-size": "14px", "line-height": j });
        $(contentClass + " div:not([cc-font-small]) p").css({ "font-size": "14px", "line-height": j });
        $(contentClass + " div:not([cc-font-medium]) p").css({ "font-size": "14px", "line-height": j });
        $(contentClass + " div:not([cc-font-large]) p").css({ "font-size": "14px", "line-height": j });
        $(contentClass + " div:not([cc-font-xlarge]) p").css({ "font-size": "14px", "line-height": j });
        $(contentClass).find(".cc-font-xxsmall p").css("font-size", "12px");
        $(contentClass).find(".cc-font-xsmall p").css("font-size", "14px");
        $(contentClass).find(".cc-font-xsmall").css("font-size", "14px");
        $(contentClass).find(".cc-font-small p").css("font-size", "16px");
        $(contentClass).find(".cc-font-small").css("font-size", "16px");
        $(contentClass).find("#notes-container .notesText").css({ "font-size": "16px", "line-height": j });
        $(contentClass).find("#notes-container .labelNoteWrapper").css({ "font-size": "16px", "line-height": j });
        $(contentClass).find(".cc-font-medium h3 p").css({ "font-size": "16px", "line-height": j });
        $(contentClass).find(".cc-font-medium").css({ "font-size": "16px", "line-height": j });
        $(contentClass).find(".cc-font-large p").css({ "font-size": "16px", "line-height": j });
        $(contentClass).find(".cc-font-large").css({ "font-size": "16px", "line-height": j });
        $(contentClass).find(".cc-font-xlarge").css({ "font-size": "18px", "line-height": j });
        $(contentClass).find(".cc-font-xlarge h2 p").css({ "font-size": "18px", "line-height": j });
        $(contentClass).find(".cc-font-xlarge h3 p").css({ "font-size": "18px", "line-height": j });
        $(contentClass).find(".cc-chapter-title h1 p").css({ "font-size": "24px", "line-height": j });
        $(contentClass).find(".cc-chapter-title").css({ "font-size": "24px", "line-height": j });
    }

    const revertToDefaultStyle = (e) => {
        revertStyleFlag = true;
        setFontSize("14");
        setLineHeight("12");
        saveEbookStyle(false);
        let contentClass = "#ereaderBookContentContainer";
        $(".ccapp-chunkHeader").removeAttr("style");
        $(contentClass + " div:not([cc-font-xxsmall]) p").removeAttr("style");
        $(contentClass + " div:not([cc-font-xsmall]) p").removeAttr("style");
        $(contentClass + " div:not([cc-font-small]) p").removeAttr("style");
        $(contentClass + " div:not([cc-font-medium]) p").removeAttr("style");
        $(contentClass + " div:not([cc-font-large]) p").removeAttr("style");
        $(contentClass + " div:not([cc-font-xlarge]) p").removeAttr("style");
        $(contentClass).find(".cc-font-xxsmall p").removeAttr("style");
        $(contentClass).find(".cc-font-xsmall p").removeAttr("style");
        $(contentClass).find(".cc-font-xsmall").removeAttr("style");
        $(contentClass).find(".cc-font-small p").removeAttr("style");
        $(contentClass).find(".cc-font-small").removeAttr("style");
        $(contentClass).find("#notes-container .notesText").removeAttr("style");
        $(contentClass).find("#notes-container .labelNoteWrapper").removeAttr("style");
        $(contentClass).find(".cc-font-medium h3 p").removeAttr("style");
        $(contentClass).find(".cc-font-medium").removeAttr("style");
        $(contentClass).find(".cc-font-large p").removeAttr("style");
        $(contentClass).find(".cc-font-large").removeAttr("style");
        $(contentClass).find(".cc-font-xlarge").removeAttr("style");
        $(contentClass).find(".cc-font-xlarge h2 p").removeAttr("style");
        $(contentClass).find(".cc-font-xlarge h3 p").removeAttr("style");
        $(contentClass).find(".cc-chapter-title h1 p").removeAttr("style");
        $(contentClass).find(".cc-chapter-title").removeAttr("style");
    }

    const updateHiddenColorsMsg = (valuechk) => {
        if (valuechk === "content") {
            let chk = document.getElementById('eBookColorPalateContainerHidden');
            setHiddenColorText((chk && chk.hasChildNodes()) ? "Click a color to add it back to your e-book highlighters." : "There are no hidden highlighters.");
        } else if (valuechk === "case") {
            let chk2 = document.querySelector('#caseBriefColorPalateContainerHidden .caseBrief_colorPalateContainer');
            setBriefHiddenColorText((chk2.hasChildNodes()) ? "Click a color to add it back to your e-book highlighters." : "There are no hidden highlighters.");
        }
    }
    const closeHighlighterCancel = () => {
        setEditHighlighterOpen(false);
        setHighlighterPopoverCancel(false);
        $('#editHighlighterId').css('visibility', 'unset');
        setTimeout(() => { $('a#collasible-setting-dropdown.dropdown-toggle.nav-link').focus(); }, 200);
    }
    const closeBriefCancel = () => {
        setBriefOpen(false);
        setBriefPopoverCancel(false);
        $('#editBriefHighlighterId').css('visibility', 'unset');
        setTimeout(() => { $('a#collasible-setting-dropdown.dropdown-toggle.nav-link').focus(); }, 200);
    }
    const decideHighLighterPopover = () => {
        if (casesFlag) {
            setBriefOpen(true);
            setBriefPopoverSave(false);
            setBriefPopoverCancel(false);
            getLatestBriefs();
        } else {
            setEditHighlighterOpen(true);
            setHighlighterPopoverSave(false);
            setHighlighterPopoverCancel(false);
            getLatestHighlights();
        }
    }
    const saveChangesBrief = () => {
        setBriefPopoverSave(true);
        $('#editBriefHighlighterId').css('visibility', 'hidden');
    }
    const goBackToBriefHighLight = () => {
        setBriefOpen(true);
        setBriefPopoverSave(false);
        $('#editBriefHighlighterId').css('visibility', 'unset');
    }
    const cancelBriefModal = () => {
        setBriefPopoverCancel(true);
        $('#editBriefHighlighterId').css('visibility', 'hidden');
    }
    const goBackToBriefHighLightFromCancel = () => {
        setBriefOpen(true);
        setBriefPopoverCancel(false);
        $('#editBriefHighlighterId').css('visibility', 'unset');
    }
    const saveChangesHighlight = () => {
        setHighlighterPopoverSave(true);
        $('#editHighlighterId').css('visibility', 'hidden');
    }
    const goBackToHighLight = () => {
        setEditHighlighterOpen(true);
        setHighlighterPopoverSave(false);
        $('#editHighlighterId').css('visibility', 'unset');
    }
    const cancelHighlightModal = () => {
        setHighlighterPopoverCancel(true);
        $('#editHighlighterId').css('visibility', 'hidden');
    }
    const goBackToHighLightFromCancel = () => {
        setEditHighlighterOpen(true);
        setHighlighterPopoverCancel(false);
        $('#editHighlighterId').css('visibility', 'unset');
    }
    const handleDropdownSubMenu = (e, id) => {
        if (e.key === 'Enter') {
            id === "ebookStyleSubMenu" ? setEBookStyleIsOpen(true) : decideHighLighterPopover();
        }
    }
    const handleRevertToDefault = (e) => {
        if (e.key === 'Enter') {
            revertToDefaultStyle(e);
        }
    }
    const hideEBookStyleModal = () => {
        setEBookStyleIsOpen(false)
        setTimeout(() => { document.getElementById('collasible-setting-dropdown').focus(); }, 200);
    }
    return (
        <React.Fragment>
            <Spinner
                loading={loadSpin}
                imageSrc={loaderColors1}
                overlayBackground="rgba(0,0,0,0.5)"
                label="Saving highlighter settings"
            />
            <NavDropdownMenu title="Settings" aria-label="Settings" id="collasible-setting-dropdown">
                <div className="navBarSettingBlock_new">
                    <span data-testid="ebookStyleSubMenu" id="ebookStyleSubMenu" onKeyDown={(e) => handleDropdownSubMenu(e, "ebookStyleSubMenu")}>
                        <DropdownSubmenu href="" aria-label="E-book Style" title={<span onClick={() => setEBookStyleIsOpen(true)}>E-book Style</span>} />
                    </span>
                    <span data-testid="highlightersSubMenu" id="highlightersSubMenu" onKeyDown={(e) => handleDropdownSubMenu(e, "highlightersSubMenu")}>
                        <DropdownSubmenu href="" aria-label="Highlighters" title={<span onClick={() => decideHighLighterPopover()}>Highlighters</span>} />
                    </span>
                </div>
            </NavDropdownMenu>
            <Modal className="modal fade" show={highlighterPopoverSave} onHide={() => goBackToHighLight()} id="highlighterSaveConfirmation" tabIndex="-1" role="dialog" aria-labelledby="highlighterSaveConfirmation">
                <div className="modal-header">
                    <h5 className="modal-title" id="HighlighterTitleSaveConfirmation">Edit Highlighters</h5>
                    <button data-testid="editHighlightersClose" className='close' type="button" data-dismiss="modal" aria-label="Close Dialog" onClick={() => goBackToHighLight()}>
                        <span aria-hidden="true" aria-label="Close Dialog" className="modal_button">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    These changes will be applied to all future highlights and case briefs for this book. Are you sure you want to make these changes?
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-primary" onClick={() => goBackToHighLight()}>No, Go Back</button>
                    <button type="button" className="btn btn-primary" aria-label={saveBtnAriaLabel} onClick={(e) => saveColorChanges(e)}>Yes, Save changes</button>
                </div>
            </Modal>
            <Modal className="modal fade" show={highlighterPopoverCancel} onHide={() => goBackToHighLightFromCancel()} id="highlighterCancelConfirmation" tabIndex="-1" role="dialog" aria-labelledby="highlighterCancelConfirmation">
                <div className="modal-header">
                    <h5 className="modal-title" id="HighlighterTitleCancelConfirmation">Cancel Changes</h5>
                    <button className='close' type="button" data-dismiss="modal" aria-label="Close Dialog" onClick={() => goBackToHighLightFromCancel()}>
                        <span aria-hidden="true" aria-label="Close Dialog" className="modal_button">&times;</span>
                    </button>
                </div>
                <div className="modal-body"> If you made changes to your highlighter settings, they will not be saved. Are you sure you want to cancel?</div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-primary" onClick={() => goBackToHighLightFromCancel()}>No, Go Back</button>
                    <button type="button" className="btn btn-primary" onClick={closeHighlighterCancel}>Yes, Cancel Changes</button>
                </div>
            </Modal>
            <Modal className="modal fade" show={briefPopoverSave} onHide={() => goBackToBriefHighLight()} id="briefSaveConfirmation" tabIndex="-1" role="dialog" aria-labelledby="briefSaveConfirmation">
                <div className="modal-header">
                    <h5 className="modal-title" id="briefTitleSaveConfirmation">Edit Highlighters</h5>
                    <button className='close' type="button" data-dismiss="modal" aria-label="Close Dialog" onClick={() => goBackToBriefHighLight()}>
                        <span aria-hidden="true" aria-label="Close Dialog" className="modal_button">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    These changes will be applied to all future highlights and case briefs for this book. Are you sure you want to make these changes?
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-primary" onClick={() => goBackToBriefHighLight()}>No, Go Back</button>
                    <button type="button" className="btn btn-primary" aria-label={saveBtnAriaLabel} onClick={(e) => saveLabelSettings(e)}>Yes, Save changes</button>
                </div>
            </Modal>
            <Modal className="modal fade" show={briefPopoverCancel} onHide={() => goBackToBriefHighLightFromCancel()} id="briefCancelConfirmation" tabIndex="-1" role="dialog" aria-labelledby="briefCancelConfirmation">
                <div className="modal-header">
                    <h5 className="modal-title" id="briefTitleCancelConfirmation">Cancel Changes</h5>
                    <button className='close' type="button" data-dismiss="modal" aria-label="Close Dialog" onClick={() => goBackToBriefHighLightFromCancel()}>
                        <span aria-hidden="true" aria-label="Close Dialog" className="modal_button">&times;</span>
                    </button>
                </div>
                <div className="modal-body"> If you made changes to your highlighter settings, they will not be saved. Are you sure you want to cancel?</div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-primary" onClick={() => goBackToBriefHighLightFromCancel()}>No, Go Back</button>
                    <button type="button" className="btn btn-primary" onClick={closeBriefCancel}>Yes, Cancel Changes</button>
                </div>
            </Modal>
            <Modal className="modal fade" show={eBookStyleIsOpen} onHide={() => hideEBookStyleModal()} id="eBookStyleModalId" tabindex="-1" role="dialog" aria-labelledby="eBookStyleModalLabel">
                <div className="modal-header">
                    <h5 className="modal-title" id="eBookStyleModalLabel">E-book Style</h5>
                    <button data-testid="closeEBookStyle" className='close' type="button" data-dismiss="modal" aria-label="Close Dialog" onClick={() => hideEBookStyleModal()}>
                        <span aria-hidden="true" aria-label="Close Dialog" className="modal_button">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="row mb-2">
                        <div className="col">
                            <label className="fontGroup_rt" for="FontSize">Font Size</label>
                            <select data-testid="fontSize" className="form-control bfh-fontsizes selectBoxFormControl_rt"
                                value={fontSize} onChange={(e) => setFontSize(e.target.value)}>
                                <option className="fontGroup_rt" value="12">12</option>
                                <option className="fontGroup_rt" value="14">14</option>
                                <option className="fontGroup_rt" value="16">16</option>
                                <option className="fontGroup_rt" value="18">18</option>
                                <option className="fontGroup_rt" value="20">20</option>
                            </select>
                        </div>
                        <div className="col">
                            <label className="fontGroup_rt" for="LineHeight">Line Height</label>
                            <select data-testid="lineHeight" className="form-control bfh-fontsizes selectBoxFormControl_rt"
                                value={lineHeight} onChange={(e) => setLineHeight(e.target.value)}>
                                <option className="fontGroup_rt" value="12">Single</option>
                                <option className="fontGroup_rt" value="15">1.5 Lines</option>
                                <option className="fontGroup_rt" value="20">Double</option>
                            </select>
                        </div>
                    </div>
                    <span data-testid="revertToDefault" tabIndex="0" onKeyDown={(e) => handleRevertToDefault(e)}>
                        <a className="reverDefault_rt mTopFive" onClick={(e) => revertToDefaultStyle(e)}>Revert to default style</a>
                    </span>
                </div>
                <div className="modal-footer mr-auto">
                    <button type="button" className="btn btn-primary" onClick={(e) => saveEbookStyle()}>Save Changes</button>
                </div>
            </Modal>
            <Modal className="modal fade" show={editHighlighterOpen} onHide={() => cancelHighlightModal()} id="editHighlighterId" tabindex="-1" role="dialog" aria-labelledby="editHighlighterLabel">
                <div className="modal-header">
                    <h5 className="modal-title" id="editHighlighterLabel">Edit Highlighters</h5>
                    <button className='close' type="button" data-dismiss="modal" aria-label="Close Dialog" onClick={() => cancelHighlightModal()}>
                        <span aria-hidden="true" aria-label="Close Dialog" className="modal_button">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <p>{selectColorText}</p>
                    <div id="eBookColorPalateContainerSelection" role="menu" aria-labelledby="HighlightSelectionPlate" className="colorPalateBtnContainer">
                        {
                            colorCodeVOList.map((cc, index) => {
                                if (cc.id === "underLine") {
                                    return state.underLineSt ? '' :
                                        <button key={index} className="underline_rt" style={{ background: "" }} aria-label="underline" colorcode="underLine" title="underLine" onClick={(e) => colorSelectionPalate1(e, 'underLine')} id="underLine"><AiOutlineUnderline /></button>
                                } else {
                                    return <button key={index} className="colorPalateBtn" style={{ backgroundColor: cc.color }} aria-label={cc.title} title={cc.title} onClick={(e) => colorSelectionPalate1(e, cc.color)} colorcode={cc.color} id={cc.id} />
                                }
                            })
                        }
                    </div>
                    <div className="hiddenEbookHighlight_rt">Hidden E-Book Highlighters</div>
                    <div className="hiddenColorText">{hiddenColorText}</div>
                    <div id="eBookColorPalateContainerHidden" role="menu" aria-labelledby="HighlightSelectionPlateHidden" className="colorPalateBtnContainer">
                        {
                            hiddenColorList.map((cc, index) => {
                                if (cc.id === "underLine") {
                                    return state.underLineStHidden ? <GrFormClose key={index} className="selected-iconUnderLine" onClick={(e) => deleteColorSelectionPalate1(e, 'underLine')} /> : '';
                                } else {
                                    return <button key={index} className="colorPalateBtn" style={{ backgroundColor: cc.highlightColorCode }} aria-label="Yellow" title="Yellow" onClick={(e) => deleteColorSelectionPalate1(e, cc.highlightColorCode)} colorcode={cc.highlightColorCode} id={cc.id} />
                                }
                            })
                        }
                    </div>
                    <div className="row">
                        <div className="modal-footer caseBriefFooter mt-4">
                            <button type="button" className="btn btn-primary" onClick={() => saveChangesHighlight()}>Save Changes</button>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal className="modal fade" show={editBriefOpen} onHide={() => cancelBriefModal()} id="editBriefHighlighterId" tabindex="-1" role="dialog" aria-labelledby="editBriefHighlighterLabel">
                <div className="modal-header">
                    <h5 className="modal-title" id="editBriefHighlighterLabel">Edit Highlighters</h5>
                    <button className='close' type="button" data-dismiss="modal" aria-label="Close Dialog" onClick={() => cancelBriefModal()}>
                        <span aria-hidden="true" aria-label="Close Dialog" className="modal_button">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <p>In the Case Briefs tab of your notebook, highlights are grouped by color. Add labels to identify the color sections or click on a color to remove it from your highlighters and case briefs.</p>
                    <div id="caseBriefColorPalateContainer" role="menu" aria-labelledby="quickHighlightSwitch" className="colorPalateBtnContainer">
                        <div className="row">
                            <div className="caseBrief_colorPalateContainer">
                                {
                                    briefCodeVOListState.map((cc, index) => {
                                        if (cc.id === "underLine") {
                                            return <div key={index} className="briefColorContainer_rt"> {state.underLineSt ? <GrFormClose className="selected-iconUnderLine" onClick={(e) => colorSelectionPalateBR(e, 'underLine')} /> :
                                                <button className="underline_rt" style={{ background: "" }} aria-label="underline" labelId={cc.labelId} labelName={cc.labelName} orderIndex={cc.orderIndex} colorcode="underLine" title="underLine" onClick={(e) => colorSelectionPalateBR(e, 'underLine')} id="underLine"><AiOutlineUnderline /></button>}
                                                <input type="text" aria-label="underLine" name="underLine" labelId={cc.labelId} labelName={cc.labelName} id={cc.inputType} colorCode={cc.colorCode} value={colorBtnTypeUnderLineBRText} onChange={(e) => handleBriefLabelName(e)} /></div>
                                        } else {
                                            let txt = cc.label;
                                            if (txt === "colorBtnTypeOneBRText") {
                                                return <div key={index} className="briefColorContainer_rt">
                                                    <button className="colorPalateBtn" style={{ backgroundColor: cc.color }} aria-label={cc.title} title={cc.title} id={cc.id} orderIndex={cc.orderIndex}
                                                        colorCode={cc.colorCode} labelId={cc.labelId} labelName={cc.label} onClick={(e) => colorSelectionPalateBR(e, cc.color)} />
                                                    <input type="text" aria-label={cc.title} name={cc.label} id={cc.inputType} value={colorBtnTypeOneBRText} onChange={(e) => handleBriefLabelName(e)} /></div>
                                            } else if (txt === "colorBtnTypeTwoBRText") {
                                                return <div key={index} className="briefColorContainer_rt">
                                                    <button className="colorPalateBtn" style={{ backgroundColor: cc.color }} aria-label={cc.title} title={cc.title} id={cc.id} orderIndex={cc.orderIndex}
                                                        colorCode={cc.colorCode} labelId={cc.labelId} labelName={cc.label} onClick={(e) => colorSelectionPalateBR(e, cc.color)} />
                                                    <input type="text" aria-label={cc.title} name={cc.label} id={cc.inputType} value={colorBtnTypeTwoBRText} onChange={(e) => handleBriefLabelName(e)} /></div>
                                            } else if (txt === "colorBtnTypeThreeBRText") {
                                                return <div key={index} className="briefColorContainer_rt">
                                                    <button className="colorPalateBtn" style={{ backgroundColor: cc.color }} aria-label={cc.title} title={cc.title} id={cc.id} orderIndex={cc.orderIndex}
                                                        colorCode={cc.colorCode} labelId={cc.labelId} labelName={cc.label} onClick={(e) => colorSelectionPalateBR(e, cc.color)} />
                                                    <input type="text" aria-label={cc.title} name={cc.label} id={cc.inputType} value={colorBtnTypeThreeBRText} onChange={(e) => handleBriefLabelName(e)} /></div>
                                            } else if (txt === "colorBtnTypeFourBRText") {
                                                return <div key={index} className="briefColorContainer_rt">
                                                    <button className="colorPalateBtn" style={{ backgroundColor: cc.color }} aria-label={cc.title} title={cc.title} id={cc.id} orderIndex={cc.orderIndex}
                                                        colorCode={cc.colorCode} labelId={cc.labelId} labelName={cc.label} onClick={(e) => colorSelectionPalateBR(e, cc.color)} />
                                                    <input type="text" aria-label={cc.title} name={cc.label} id={cc.inputType} value={colorBtnTypeFourBRText} onChange={(e) => handleBriefLabelName(e)} /></div>
                                            } else if (txt === "colorBtnTypeFiveBRText") {
                                                return <div key={index} className="briefColorContainer_rt">
                                                    <button className="colorPalateBtn" style={{ backgroundColor: cc.color }} aria-label={cc.title} title={cc.title} id={cc.id} orderIndex={cc.orderIndex}
                                                        colorCode={cc.colorCode} labelId={cc.labelId} labelName={cc.label} onClick={(e) => colorSelectionPalateBR(e, cc.color)} />
                                                    <input type="text" aria-label={cc.title} name={cc.label} id={cc.inputType} value={colorBtnTypeFiveBRText} onChange={(e) => handleBriefLabelName(e)} /></div>
                                            } else if (txt === "colorBtnTypeSixBRText") {
                                                return <div key={index} className="briefColorContainer_rt">
                                                    <button className="colorPalateBtn" style={{ backgroundColor: cc.color }} aria-label={cc.title} title={cc.title} id={cc.id} orderIndex={cc.orderIndex}
                                                        colorCode={cc.colorCode} labelId={cc.labelId} labelName={cc.label} onClick={(e) => colorSelectionPalateBR(e, cc.color)} />
                                                    <input type="text" aria-label={cc.title} name={cc.label} id={cc.inputType} value={colorBtnTypeSixBRText} onChange={(e) => handleBriefLabelName(e)} /></div>
                                            } else if (txt === "colorBtnTypeSevenBRText") {
                                                return <div key={index} className="briefColorContainer_rt">
                                                    <button className="colorPalateBtn" style={{ backgroundColor: cc.color }} aria-label={cc.title} title={cc.title} id={cc.id} orderIndex={cc.orderIndex}
                                                        colorCode={cc.colorCode} labelId={cc.labelId} labelName={cc.label} onClick={(e) => colorSelectionPalateBR(e, cc.color)} />
                                                    <input type="text" aria-label={cc.title} name={cc.label} id={cc.inputType} value={colorBtnTypeSevenBRText} onChange={(e) => handleBriefLabelName(e)} /></div>
                                            } else if (txt === "colorBtnTypeEightBRText") {
                                                return <div key={index} className="briefColorContainer_rt">
                                                    <button className="colorPalateBtn" style={{ backgroundColor: cc.color }} aria-label={cc.title} title={cc.title} id={cc.id} orderIndex={cc.orderIndex}
                                                        colorCode={cc.colorCode} labelId={cc.labelId} labelName={cc.label} onClick={(e) => colorSelectionPalateBR(e, cc.color)} />
                                                    <input type="text" aria-label={cc.title} name={cc.label} id={cc.inputType} value={colorBtnTypeEightBRText} onChange={(e) => handleBriefLabelName(e)} /></div>
                                            } else if (txt === "colorBtnTypeNineBRText") {
                                                return <div key={index} className="briefColorContainer_rt">
                                                    <button className="colorPalateBtn" style={{ backgroundColor: cc.color }} aria-label={cc.title} title={cc.title} id={cc.id} orderIndex={cc.orderIndex}
                                                        colorCode={cc.colorCode} labelId={cc.labelId} label={cc.label} onClick={(e) => colorSelectionPalateBR(e, cc.color)} />
                                                    <input type="text" aria-label={cc.title} name={cc.label} id={cc.inputType} value={colorBtnTypeNineBRText} onChange={(e) => handleBriefLabelName(e)} /></div>
                                            } else if (txt === "colorBtnTypeTenBRText") {
                                                return <div key={index} className="briefColorContainer_rt">
                                                    <button className="colorPalateBtn" style={{ backgroundColor: cc.color }} aria-label={cc.title} title={cc.title} id={cc.id} orderIndex={cc.orderIndex}
                                                        colorCode={cc.colorCode} labelId={cc.labelId} labelName={cc.label} onClick={(e) => colorSelectionPalateBR(e, cc.color)} />
                                                    <input type="text" aria-label={cc.title} name={cc.label} id={cc.inputType} value={colorBtnTypeTenBRText} onChange={(e) => handleBriefLabelName(e)} /></div>
                                            } else if (txt === "colorBtnTypeElevenBRText") {
                                                return <div key={index} className="briefColorContainer_rt">
                                                    <button className="colorPalateBtn" style={{ backgroundColor: cc.color }} aria-label={cc.title} title={cc.title} id={cc.id} orderIndex={cc.orderIndex}
                                                        colorCode={cc.colorCode} labelId={cc.labelId} labelName={cc.label} onClick={(e) => colorSelectionPalateBR(e, cc.color)} />
                                                    <input type="text" aria-label={cc.title} name={cc.label} id={cc.inputType} value={colorBtnTypeElevenBRText} onChange={(e) => handleBriefLabelName(e)} /></div>
                                            }
                                        }
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div className="hiddenEbookHighlight_rt">Hidden E-Book Highlighters</div>
                    <div className="">{briefHiddenColorText}</div>
                    <div id="caseBriefColorPalateContainerHidden" role="menu" aria-labelledby="quickHighlightSwitch" className="caseBriefColorPalateContainerHidden">
                        <div className="row">
                            <div className="caseBrief_colorPalateContainer">
                                {
                                    hiddenColorBriefListState.map((cc, index) => {
                                        if (cc.id === "underLine") {
                                            return state.underLineSt ? <GrFormClose className="selected-iconUnderLine" onClick={(e) => deleteColorSelectionPalate1(e, 'underLine')} /> :
                                                <button data-testid={cc.id} className="underline_rt" style={{ background: "" }} aria-label="underline" colorcode="underLine" title="underLine" onClick={(e) => deleteColorSelectionPalate1(e, 'underLine')} id="underLine"><AiOutlineUnderline /></button>
                                        } else {
                                            return <button data-testid={cc.id} className="colorPalateBtn" style={{ backgroundColor: cc.color, marginTop: '5px' }} aria-label={cc.title} title={cc.title} id={cc.id} colorcode={cc.color}
                                                onClick={(e) => deleteColorSelectionPalateBR(e, cc.color)} />
                                        }
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="modal-footer caseBriefFooter mt-4">
                            <button type="button" className="btn btn-primary" onClick={() => saveChangesBrief()}>Save Changes</button>
                        </div>
                    </div>
                </div>
            </Modal>
        </React.Fragment>
    )
}
export default withRouter(SettingsMenu);
